import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Link, useMatch } from "../../../vendor/router-ROUTER_TARGET";
import './SubMenu.css';

function ConnectedSubMenu({ label, style, to, or = null, activeOnlyWhenExact, storeRoute }) {
  // v6 dialect (see vendor/router-v5.js): `exact` -> `end`, and the match must be
  // asked for exact up front — `isExact` is a v5-only field on the result.
  let match = useMatch({ path: to, end: !!activeOnlyWhenExact });
  let matchOr = useMatch({ path: or, end: true });
  const setHistory = () => { storeRoute.goTo(to); }

  const isSelected = (match || matchOr);

  return (
    <Link onClick={setHistory} style={{ textDecoration: `none`}} to={to}>
      <div className={`small-button sub-menu ${isSelected && `sub-menu-selected`} `} style={style}>
        <span className={`type-medium fz16`} >{label}</span>
      </div>
    </Link>
  )
}

ConnectedSubMenu.propTypes = {
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
  to: PropTypes.string.isRequired,
  activeOnlyWhenExact: PropTypes.any
}

const SubMenu = connect(
  state => ({
    storeRoute: state.storeRoute
  })
)(ConnectedSubMenu);

export default SubMenu;
